// extracted by mini-css-extract-plugin
export default {"PrivacyPolicy":"PrivacyPolicy_PrivacyPolicy__pyMFZ","PrivacyPolicy_ContentContainer":"PrivacyPolicy_PrivacyPolicy_ContentContainer__bDD2F"};